let triggered = false;

/* ===============================
 Shopify Live Chat Trigger
 Opens Online Store Chat (Inbox) when clicking .open_livechat
 Waits for deferred #ShopifyChat if the script gate hasn't loaded it yet.
================================ */
function getShopifyActivatorButton() {
  const chatEl = document.querySelector('shopify-chat');
  if (!chatEl || !chatEl.shadowRoot) return null;

  return chatEl.shadowRoot.querySelector('button.activator');
}

function openShopifyOnlineStoreChat() {
  function tryOpen() {
    const btn = getShopifyActivatorButton();
    if (!btn) return false;
    btn.click();
    return true;
  }

  if (tryOpen()) return;

  let tries = 0;
  const timer = setInterval(function () {
    tries += 1;
    if (tryOpen() || tries > 60) clearInterval(timer);
  }, 100);
}

function initShopifyChatTrigger() {
  if (window.__ssChatTriggerBound) return;
  window.__ssChatTriggerBound = true;

  document.addEventListener('click', function (event) {
    const link = event.target.closest('.open_livechat');
    if (!link) return;
    event.preventDefault();
    openShopifyOnlineStoreChat();
  });
}

/* ===============================
 Lazy Load Images & Pictures
================================ */
function lazyLoadPictures() {
  document.querySelectorAll('picture.lazy-load, img.lazy-load').forEach(el => {
    let img;

    if (el.tagName === 'PICTURE') {
      el.querySelectorAll('source').forEach(source => {
        if (source.dataset.srcset) {
          source.srcset = source.dataset.srcset;
          source.removeAttribute('data-srcset');
        }
      });
      img = el.querySelector('img');
    } else {
      img = el;
      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
        img.removeAttribute('data-srcset');
      }
    }

    if (!img || !img.dataset.src) return;

    const loader = document.createElement('div');
    loader.className = 'image-loader';
    img.parentElement.appendChild(loader);

    img.src = img.dataset.src;
    img.removeAttribute('data-src');
    img.classList.remove('lazy-load');

    img.onload = img.onerror = () => loader.remove();
  });
}

/* ===============================
 Lazy Load Videos
================================ */
function lazyLoadVideos() {
  document.querySelectorAll('video.lazy-load').forEach(video => {
    video.querySelectorAll('source').forEach(source => {
      if (source.dataset.src) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      }
    });

    if (video.dataset.poster) {
      video.poster = video.dataset.poster;
      video.removeAttribute('data-poster');
    }

    video.load();
    video.classList.remove('lazy-load');
  });
}

/* ===============================
 Metafield Link Boxes Slider
================================ */
function initMetafieldLinkBoxesSlider() {
  document.querySelectorAll('.custom-link-boxes-wrapper').forEach(wrapper => {
    const prevBtn = wrapper.querySelector('.button-prev');
    const nextBtn = wrapper.querySelector('.button-next');
    if (!prevBtn || !nextBtn) return;

    wrapper.querySelectorAll(
      '.metafield-rich_text_field, .link-boxes-margin-container .link-boxes_wrapper'
    ).forEach(scrollContainer => {
      const items = scrollContainer.querySelectorAll('li, p');

      if (!items.length) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
        return;
      }

      scrollContainer.style.overflowX = 'auto';
      scrollContainer.style.whiteSpace = 'nowrap';

      const scrollAmount = 200;

      const updateArrows = () => {
        const maxScroll =
          scrollContainer.scrollWidth - scrollContainer.clientWidth;

        prevBtn.style.display =
          scrollContainer.scrollLeft > 0 ? 'block' : 'none';

        nextBtn.style.display =
          scrollContainer.scrollLeft < maxScroll ? 'block' : 'none';
      };

      updateArrows();
      scrollContainer.addEventListener('scroll', updateArrows);
      window.addEventListener('resize', updateArrows);

      prevBtn.onclick = () =>
        scrollContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });

      nextBtn.onclick = () =>
        scrollContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  });
}

/* ===============================
 Header Hover Dropdown
================================ */
function initHeaderMenuHover(selector = 'header-menu > details > summary') {
  if (!window.matchMedia('(hover: hover)').matches) return;

  document.querySelectorAll(selector).forEach(summary => {
    const details = summary.parentElement;
    
    summary.addEventListener('mouseenter', () => {
      details.open = true;
    });
    
    details.addEventListener('mouseleave', () => {
      details.open = false;
    });
  });
  const submenus = document.querySelectorAll('.grandchild__submenu');
  
  submenus.forEach(menu => {
    menu.addEventListener('toggle', () => {
      if (menu.open) {
        submenus.forEach(otherMenu => {
          if (otherMenu !== menu) {
            otherMenu.removeAttribute('open');
          }
        });
      }
    });
  });
}

/* ===============================
 Swiper Inits
================================ */

function initProductSwipers() {
  if (!window.location.pathname.startsWith("/products")) return;
  const settings = {
    slidesPerView: 2,
    spaceBetween: 15,
    loop: true,
    breakpoints: {
      640:  { slidesPerView: 2, spaceBetween: 15 },
      768:  { slidesPerView: 3, spaceBetween: 15 },
      980:  { slidesPerView: 4, spaceBetween: 25 },
      1200: { slidesPerView: 5, spaceBetween: 25 },
    },
  };
  
  new Swiper('.product-recommendations-swiper', {
    ...settings,
    navigation: {
      nextEl: '.product-recommendations-swiper .swiper-button-next',
      prevEl: '.product-recommendations-swiper .swiper-button-prev',
    },
  });
  
  new Swiper('.product-recommendations-swiper2', {
    ...settings,
    navigation: {
      nextEl: '.product-recommendations-swiper2 .swiper-button-next',
      prevEl: '.product-recommendations-swiper2 .swiper-button-prev',
    },
  });
  
  new Swiper('.product-recommendations-swiper3', {
    ...settings,
    navigation: {
      nextEl: '.product-recommendations-swiper3 .swiper-button-next',
      prevEl: '.product-recommendations-swiper3 .swiper-button-prev',
    },
  });
  
}

function initBestSellerSwiper() {
  return new Swiper('.best-seller-swiper', {
    slidesPerView: 2,
    loop: true,
    spaceBetween: 16,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      640: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 6,
      },
    }
  });
  
}


function TrendingSwiper() {
  return new Swiper('.trending-products', {
    slidesPerView: 2,
    loop: true,
    spaceBetween: 16,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      640: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 6,
      },
    }
  });
  
}

/* ===============================
 Category Gallery Anim Inits
================================ */

function initCategoryGalleryMarquee() {
  const swiper = new Swiper('.mm-category-gallery__inner', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    loop: true,
    loopAdditionalSlides: 5,

    speed: 3000,
    allowTouchMove: true,

    freeMode: true,
    freeModeMomentum: false,

    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },

    grabCursor: true,
    watchOverflow: true,
  });

}

// /* ===============================
//  Css Lazyload
// ================================ */

function loadLazyCSS() {
  if (window.LAZY_CSS_TRIGGERED) return;
  window.LAZY_CSS_TRIGGERED = true;

  const lazyCSSFiles = window.LAZY_CSS_FILES || [];

  lazyCSSFiles.forEach(href => {
    if (document.querySelector('link[href="' + href + '"]')) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.media = 'all';
    document.head.appendChild(link);
  });
}


/* ===============================
 Master Initializer
================================ */
function runAllDeferredFeatures() {
  if (triggered) return;
  triggered = true;

  lazyLoadPictures();
  lazyLoadVideos();
  initBestSellerSwiper();
  initMetafieldLinkBoxesSlider();
  initHeaderMenuHover();
  initProductSwipers();
  initCategoryGalleryMarquee();
  loadLazyCSS();
  TrendingSwiper();

}

/* ===============================
 Interaction-based Trigger
================================ */
(function () {
  ['scroll', 'mousemove', 'touchstart', 'keydown', 'click'].forEach(evt => {
    window.addEventListener(evt, runAllDeferredFeatures, {
      once: true,
      passive: true
    });
  });
  
  ['facet:update', 'theme:loading:end'].forEach(evt => {
    window.addEventListener(evt, () => {
      setTimeout(() => {
        triggered = false; // allow re-run
        runAllDeferredFeatures();
      }, 100);
    });
  });
})();

/* ===============================
 Initial Trigger
================================ */
initShopifyChatTrigger();
initProductSwipers();
/* ===============================
 Delayed After-Load Trigger
================================ */
function onPageFullyLoaded(cb) {
  if (document.readyState === 'complete') {
    cb();
  } else {
    window.addEventListener('load', cb);
  }
}

onPageFullyLoaded(function () {
  initProductSwipers();
});

